import { SET_LOADER } from "../constants/mutations.type";

export default {
  [SET_LOADER](state, payload) {
    state.isLoading = payload;
  }
};
